<div class="icons screen-element {{classes}}" [ngClass]="{'debug':debug}">
	<div class="icon" *ngIf="hasH2()" [ngClass]="getH2Class()"><span class="h2h">H</span><span class="h22">2</span></div>
	<div class="icon" *ngIf="hasBurner()" [ngClass]="getBurnerClass()"></div>
	<div class="icon" *ngIf="hasHeating()" [ngClass]="getHeatingClass()"></div>
	<div class="icon" *ngIf="hasDHW()" [ngClass]="getDHWClass()"></div>
	<div class="icon" *ngIf="hasWaterPressure()" [ngClass]="getPressureClass()"></div>
	<div class="icon iconGreenIQGrey" *ngIf="greenIq()" [ngClass]="{'debug':debug}"></div>
	<div class="icon iconOperationTimeGrey" *ngIf="timerActive()" [ngClass]="{'debug':debug}"></div>
	<div class="icon iconComfortModeGrey" *ngIf="comfortModeActive()" [ngClass]="{'debug':debug}"></div>


	<div class="icon iconRadioConnectionGrey" *ngIf="hasRadio()" [ngClass]="{'debug':debug}"></div>
	<div class="icon iconBatteryFullGrey" *ngIf="hasBattery()" [ngClass]="{'debug':debug}"></div>
	<div class="icon iconLockedGrey" *ngIf="isLocked()" [ngClass]="{'debug':debug}"></div>
	<div class="icon iconCompetentPersonInstallerGrey" *ngIf="serviceDateExpired()" [ngClass]="{'debug':debug}"></div>
</div>